import { headerSearchBarFix, updateContentMargin, modifyFeatureLineup } from './utils/helpers';
import { setNavItemAttributes, updateMenuButton } from './utils/handleNavigation';

const socialNetworksMql = window.matchMedia('(min-width: 1071px)'); // espejo de (width > 1070px) en _socialWidget.scss

function syncSocialNetworks(mql) {
  const $footerSocial = $('.footer-left .socialNetworks');
  const $main = $('main.content');
  if (!$footerSocial.length || !$main.length) return;

  if (mql.matches) {
    if (!$main.find('.socialNetworks').length) {
      const $clone = $footerSocial.clone();
      $clone.find('[id]').removeAttr('id');
      $main.append($clone);
    }
  } else {
    $main.find('.socialNetworks').remove();
  }
}

$(document).ready(function () {
  $('.generalmessage').prependTo('header');
  headerSearchBarFix('Search website');
  updateMenuButton();
  modifyFeatureLineup();
  syncSocialNetworks(socialNetworksMql);

  socialNetworksMql.addEventListener('change', syncSocialNetworks);

  $(globalThis).on('load', function () {
    setNavItemAttributes();
    updateContentMargin();
  });
});
